import { Container } from '@pixi/react';
import { ReactElement, useEffect, useRef } from 'react';

export const FullScreenComponent: React.FC<{ children?: ReactElement }> = ({ children }) => {
  const ref = useRef<any>();

  useEffect(() => {
    const updateContainer = () => {
      if (!ref.current) return;

      const app = (window as any).__PIXI_APP__;
      const stageWidth = app?.renderer?.screen?.width ?? window.innerWidth;
      const stageHeight = app?.renderer?.screen?.height ?? window.innerHeight;
      const prevWidth: number = ref.current.width || stageWidth;

      ref.current.width = stageWidth;
      ref.current.height *= stageWidth / prevWidth;
      ref.current.x = stageWidth / 2;
      ref.current.y = stageHeight / 2;
    };

    updateContainer();
    window.addEventListener('resize', updateContainer);
    window.addEventListener('orientationchange', updateContainer);

    return () => {
      window.removeEventListener('resize', updateContainer);
      window.removeEventListener('orientationchange', updateContainer);
    };
  }, []);

  return (
    <Container {...({ name: 'FullScreenContainer' })} ref={ref}>
      {children}
    </Container>
  );
};
